/***
 * BEGIN Null Shims
 *
 * DDD 2018-08-09
 * these globally-defined objects have no value (functions do nothing), but
 * are used to fix reference errors server-side in libraries that must be
 * included in the project.
 *
 *
 * No names that are defined in Null Shims should be used in
 * 1) code that could run server side,
 * or
 * 2) code that fails to test these values
 * for null.
 *
 * ok:
 * componentDidMount() {
 *   // we're in the browser here
 *   window.location = "example.com";
 * }
 *
 * ok:
 * if (window.location){
 *   // we're sure location is something
 *   window.location = "example.com";
 * }
 *
 * not ok: *
 * window.location = "example.com"
 * 
 */

// window
if (typeof window === 'undefined') {
	var window = global.window = {};
}

// document
if (typeof document === 'undefined') {
	global.document = {};
}

// setTimeout
if (!window['setTimeout']) {
    window.setTimeout = (function() {

    });
}
if (typeof setTimeout === 'undefined') {
    setTimeout = window.setTimeout;
}

// clearTimeout
if (!window['clearTimeout']) {
    window.clearTimeout = (function() {

    });
}
if (typeof clearTimeout === 'undefined') {
    clearTimeout = window.clearTimeout;
}

/***
 * END Null Shims
 */

/***
 * Begin replacement shims
 * These shims should work like the native browser when
 * used server-side.
 */


// https://github.com/uxitten/polyfill/blob/master/string.polyfill.js
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/padStart
if (!String.prototype.padStart) {
    String.prototype.padStart = function padStart(targetLength,padString) {
        targetLength = targetLength>>0; //truncate if number or convert non-number to 0;
        padString = String((typeof padString !== 'undefined' ? padString : ' '));
        if (this.length > targetLength) {
            return String(this);
        }
        else {
            targetLength = targetLength-this.length;
            if (targetLength > padString.length) {
                padString += padString.repeat(targetLength/padString.length); //append to original to ensure we are longer than needed
            }
            return padString.slice(0,targetLength) + String(this);
        }
    };
}


// WEBPACK FOOTER //
// ./src/shims/servershims.js